import { render } from "./InvestmentCooperationRussia.vue?vue&type=template&id=cecba3c6"
import script from "./InvestmentCooperationRussia.vue?vue&type=script&lang=js"
export * from "./InvestmentCooperationRussia.vue?vue&type=script&lang=js"

import "./InvestmentCooperationRussia.vue?vue&type=style&index=0&id=cecba3c6&lang=scss"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__